import React, { useState, useEffect } from 'react';
import './Employeeproductivity.css'; // Import the CSS file for styling

const EmployeeProductivity = () => {
  const [employees, setEmployees] = useState([]); // State for storing all employees' data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Fetch employee productivity on component mount
  useEffect(() => {
    const fetchEmployeesData = async () => {
      console.log('Fetching employee productivity data from the backend...');

      try {
        const response = await fetch('https://cleezoclass.com:8443/api/employee-productivity');
        console.log('API Response:', response);

        const data = await response.json();
        console.log('Employee Data:', data);

        if (response.ok) {
          setEmployees(data); // Set the employee data to state
        } else {
          setError('Error fetching employee productivity');
        }
      } catch (err) {
        console.error('Error fetching employees data:', err);
        setError('Error fetching employee productivity');
      } finally {
        setLoading(false); // Stop loading
        console.log('Loading finished');
      }
    };

    fetchEmployeesData();
  }, []); // Run this effect only once when the component mounts

  if (loading) return <p className="employee-productivity-loading-msg">Loading...</p>;
  if (error) return <p className="employee-productivity-error-msg">{error}</p>;

  return (
    <div className="employee-productivity-fullscreen-container">
      <h2 className="employee-productivity-heading">Employee Productivity</h2>
      <div className="employee-productivity-cards-container">
        {employees.map((employee) => (
          <div className="employee-productivity-card" key={employee.empId}>
            <div className="employee-productivity-details">
              <p><strong>ID:</strong> {employee.empId}</p>
              <p><strong>Name:</strong> {employee.empName}</p>
              <p><strong>Designation:</strong> {employee.designation}</p>
              {employee.surplusHours > 0 && (
                <p><strong>Surplus Hours:</strong> {employee.surplusHours.toFixed(2)} hrs</p>
              )}
              {employee.overrunHours > 0 && (
                <p><strong>Overrun Hours:</strong> {employee.overrunHours.toFixed(2)} hrs</p>
              )}
            </div>
            <div
              className={`employee-productivity-indicator employee-productivity-${employee.productivityStatus.toLowerCase()}`}
              style={{ backgroundColor: employee.color }}
              title={`Productivity: ${employee.productivityStatus}`}
            >
              {employee.productivityStatus}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployeeProductivity;
